import React from "react";
import { connect } from "react-redux";
import Table from "react-bootstrap/Table";

const AgentsUnavailable = props => {
  const tableBody = props.agents_unavailable_list.map((agent, idx) => {
    return (
      <tr key={agent.id}>
        <td>{idx + 1}</td>
        <td>{agent.name}</td>
        <td>{agent.status}</td>
        <td>{agent.logged_in_time}</td>
        <td>{agent.queues[0]}</td>
        <td>{agent.missed_calls}</td>
      </tr>
    );
  });

  return (
    <Table striped bordered hover variant="dark">
      <thead>
        <tr>
          <th>#</th>
          <th>Agent</th>
          <th>Status(Duration)</th>
          <th>Logged In(Duration)</th>
          <th>Queue Name</th>
          <th>Missed Calls</th>
        </tr>
      </thead>
      <tbody>{tableBody}</tbody>
    </Table>
  );
};

const mapStateToProps = state => {
  return {
    agents_unavailable_list: state.rmqReducer.agents.agents_unavailable_list,
  };
};
export default connect(mapStateToProps, {})(AgentsUnavailable);
